import { render, staticRenderFns } from "./TabCell.vue?vue&type=template&id=595bacc3"
import script from "./TabCell.vue?vue&type=script&lang=ts"
export * from "./TabCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports